import React, { ReactElement, useRef } from 'react';
import { CoverageCheckupState } from '../../../store/step';
import Input from '@ramsey-design-system/input';
import { FormikFormField } from '@frontman/rt-protections-ui';

function UserInformationForm(): ReactElement {
  return (
    <>
      <FormikFormField<CoverageCheckupState>
        name="firstName"
        inputComponent={Input}
        id="firstName"
        rdsAttributes={{
          label: 'First Name',
          length: 'sm',
        }}
        htmlAttributes={{ maxLength: 50 }}
      />
      <FormikFormField<CoverageCheckupState>
        name="lastName"
        inputComponent={Input}
        id="lastName"
        rdsAttributes={{
          label: 'Last Name',
          length: 'sm',
        }}
        htmlAttributes={{ maxLength: 50 }}
      />
      <FormikFormField<CoverageCheckupState>
        name="email"
        inputComponent={Input}
        id="email"
        rdsAttributes={{
          label: 'Email',
          length: 'md',
        }}
        htmlAttributes={{ maxLength: 50 }}
      />
    </>
  );
}

export { UserInformationForm };
